// ###########################################################################
// jq.ux.js  —  UX front + editeur de blocs
//
// Ce fichier est concatene dans dist/scripts/main.js (voir assets/manifest.json)
// et charge :
//   - en front            via lib/assets.php > assets()                (script "app")
//   - dans l'editeur      via lib/assets.php > enqueue_block_*_assets  (script "app-editor")
//
// Depuis le passage des blocs ACF en `api_version => 3` (inc/customs-guntenberg.php)
// le canevas de l'editeur est rendu dans une <iframe> et l'apercu d'un bloc est
// re-injecte en Ajax a chaque modification de champ. Les initialisations doivent
// donc respecter 3 regles :
//   1. ne jamais lever d'exception si un element ou une librairie est absent
//      (une erreur ici casse tout le JS de la page, editeur compris) ;
//   2. etre rejouables sur un sous-arbre du DOM (l'apercu d'un bloc) sans
//      double-initialiser slick / masonry / fancybox ;
//   3. rester inoffensives si le script est charge deux fois dans la meme
//      fenetre (les hooks `enqueue_block_assets` se declenchent aussi en front).
// ###########################################################################

(function ($) {

  if (!$) { return; }

  var win = window;

  // Contexte editeur : iframe du canevas, page block-editor, ou /wp-admin/.
  var isEditor =
    win.self !== win.top ||
    (document.body && document.body.classList.contains('block-editor-page')) ||
    /\/wp-admin\//.test(win.location.pathname);

  // ---------------------------------------------------------------------------
  // Initialisations de composants — idempotentes, rejouables sur un sous-arbre.
  // `root` : un jQuery/DOM (apercu de bloc) ou rien (= document entier).
  // ---------------------------------------------------------------------------
  function initComponents(root) {

    var $root = root && root.jquery ? root : $(root || document);

    // find() + le noeud racine lui-meme (l'apercu ACF peut ETRE la section)
    function scope(selector) {
      return $root.find(selector).add($root.filter(selector));
    }

    // Dans l'editeur de blocs, on N'initialise PAS slick / masonry / la
    // lightbox : ces libs mesurent la largeur du conteneur au moment de
    // l'init, or l'apercu ACF (api v3, iframe) est souvent encore a 0px =>
    // slides empilees a 50vh/100vh chacune => apercu de 4000px sans images.
    // Un fallback CSS (.acf-block-preview, voir lib/assets.php > editeur)
    // affiche les items en bande horizontale, lisible et sans JS.
    if (isEditor) {
      scope('.animated').addClass('active');
      return;
    }

    // --- SLICK : slideshow & sliders ----------------------------------------
    if (typeof $.fn.slick !== 'undefined') {

      scope('.content-slider-1-1 .wrapper-slider > .content')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

      scope('.content-1-1 .wrapper .gallery')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000
        });

      scope('.block-room .wrapper .gallery-room .wrapper-slider')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000
        });

      scope('.content-slider-bedroom .wrapper > .content')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000
        });

      scope('.content-video-fullscreen .wrapper-slideshow')
        .not('.slick-initialized')
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          arrows: false,
          pauseOnFocus: false,
          fade: true,
          cssEase: 'ease-in-out'
        });
    }

    // --- MASONRY : grille de temoignages ----------------------------------
    if (typeof $.fn.masonry !== 'undefined') {
      scope('.wrapper-testimonial').each(function () {
        var $grid = $(this);
        if ($grid.data('masonry')) {
          $grid.masonry('reloadItems');
          $grid.masonry('layout');
        } else {
          $grid.masonry({
            itemSelector: '.item',
            columnWidth: '.item',
            percentPosition: true,
            gutter: 20
          });
        }
      });
    }

    // --- GALERIE PHOTO : wrap <a data-fancybox> autour des images ----------
    scope('.wp-block-gallery-1 .wp-block-image img').each(function () {
      var $img = $(this);

      if ($img.closest('a[data-fancybox]').length) {
        return; // deja enrobee
      }

      var fullImage = $img.attr('src');

      if ($img.attr('srcset')) {
        var srcset = $img.attr('srcset').split(',');
        fullImage = srcset[srcset.length - 1].trim().split(' ')[0];
      }

      $img.wrap('<a href="' + fullImage + '" data-fancybox="haulme-gallery"></a>');
    });

    // --- FANCYBOX ---------------------------------------------------------
    // Fancybox.bind() delegue au document : on ne le lie qu'une seule fois
    // par fenetre pour ne pas empiler les ecouteurs (ouvertures multiples).
    if (typeof win.Fancybox !== 'undefined' && !win.__haulmeFancybox) {
      win.__haulmeFancybox = true;

      win.Fancybox.bind('[data-fancybox="haulme-gallery"]', {
        Thumbs: false,
        Toolbar: { display: ['close'] }
      });

      win.Fancybox.bind('[data-fancybox="gallery"]', {
        Thumbs: { autoStart: true },
        Toolbar: { display: ['zoom', 'close'] }
      });
    }
  }

  // ---------------------------------------------------------------------------
  // Handlers globaux (scroll, navigation, ancres) — une seule fois par fenetre.
  // ---------------------------------------------------------------------------
  function initGlobalHandlers() {

    // --- HEADER : classe .min au scroll ---------------------------------
    var $mainHeader = $('.main-header');

    if ($mainHeader.length) {
      var updateHeaderState = function () {
        $mainHeader.toggleClass('min', $(win).scrollTop() > 300);
      };

      $(win).on('scroll', updateHeaderState);
      updateHeaderState();
      $(win).on('load', updateHeaderState);
    }

    // --- ANIMATION FADE TO TOP au scroll -------------------------------
    var $window = $(win);

    function check_if_in_view() {
      var $animation_elements = $('.animated');

      if (!$animation_elements.length) { return; }

      var window_top_position = $window.scrollTop();
      var window_bottom_position = window_top_position + $window.height();

      $.each($animation_elements, function () {
        var $element = $(this);
        var offset = $element.offset();

        if (!offset) { return; } // element detache / masque

        var element_top_position = offset.top;
        var element_bottom_position = element_top_position + $element.outerHeight();

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
          $element.addClass('active');
        }
      });
    }

    $window.on('scroll resize', check_if_in_view);
    $window.trigger('scroll');

    // --- NAVIGATION MOBILE --------------------------------------------
    $(document).on('click', '#btnMobile', function () {
      $(this).toggleClass('cross');
      $('.main-nav-wrapper').toggleClass('open');
      $('body').toggleClass('overflow');
    });

    // --- SOUS-MENUS -------------------------------------------------
    $(document).on('click', 'ul > li.menu-item-has-children > a', function (e) {
      e.preventDefault();

      var $li = $(this).parent();
      var className = $li.attr('class') || '';

      if (className.indexOf('openSub-menu') === -1) {
        $('ul > li.menu-item-has-children').removeClass('openSub-menu');
      }

      $li.toggleClass('openSub-menu');
    });

    // Fermeture des sous-menus au clic exterieur
    $(document).on('click', function (event) {
      var $trigger = $('.menu-item-has-children');
      if (!$trigger.is(event.target) && !$trigger.has(event.target).length) {
        $trigger.removeClass('openSub-menu');
      }
    });

    // --- ANCRES : scroll anime ------------------------------------
    $(document).on('click', 'a[href^="#"]', function (e) {
      var target = this.hash;

      if (!target || target === '#') { return; }

      var $target = $(target);
      if (!$target.length) { return; }

      e.preventDefault();

      var navHeight = $('nav').length ? $('nav').height() : 0;

      $('html, body').stop().animate({
        scrollTop: $target.offset().top - navHeight
      }, 1200, 'swing', function () {
        win.location.hash = target;
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Amorcage
  // ---------------------------------------------------------------------------

  // Handlers globaux : une fois par fenetre (le script peut etre enqueue 2x).
  if (!win.__haulmeUxBooted) {
    win.__haulmeUxBooted = true;
    $(function () { initGlobalHandlers(); });
  }

  // Composants : au chargement...
  $(function () { initComponents(document); });

  // ...et a chaque (re)rendu d'apercu ou d'ajout de bloc dans l'editeur ACF.
  if (win.acf && typeof win.acf.addAction === 'function') {
    win.acf.addAction('render_block_preview', function (el) { initComponents($(el)); });
    win.acf.addAction('append', function (el) { initComponents($(el)); });
  }

})(window.jQuery);
